export default "__VITE_ASSET__p3shlpiZ__"